export const CATEGORIA_SEXOS = [
  { value: 'DAMAS', label: 'Damas' },
  { value: 'CABALLEROS', label: 'Caballeros' },
];

export const sexoCategoriaLabel = (sexo) =>
  CATEGORIA_SEXOS.find((s) => s.value === sexo)?.label || sexo || '';

export const categoriaLabel = (cat) => {
  if (!cat) return '';
  const sexo = sexoCategoriaLabel(cat.cat_sexo);
  return sexo ? `${cat.cat_descripcion} · ${sexo}` : cat.cat_descripcion;
};
